import { useState } from 'react';
import './Modal.css';

export default function Modal({ open, onClose }) {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = () => {
    if (!email.includes('@')) return;
    setSuccess(true);
    setEmail('');
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-box">
        <button className="modal-close" onClick={onClose}>×</button>
        <span className="modal-eyebrow">Early Access</span>
        <h2 className="modal-title">Happy to have you.</h2>
        <p className="modal-sub">
          Drop your email — we'll reach out when TAGpdf is ready. No spam, ever.
        </p>
        <div className="modal-input-row">
          <input
            type="email"
            className="modal-input"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          />
          <button className="modal-send" onClick={handleSubmit}>Send →</button>
        </div>
        {success && (
          <div className="modal-success">● You're on the list. We'll be in touch.</div>
        )}
        <p className="modal-note">No account · No upload · No exceptions</p>
      </div>
    </div>
  );
}
